import React from 'react'
import './ReadyToPlay.css'
import { Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import StoreButtons from '../../../Common/Buttons/StoreButtons'

const { Title, Paragraph } = Typography

const ReadyToPlay: React.FC = () => {
    const { t } = useTranslation()

    return (
        <div className="readytoplay-container">
            <div className="readytoplay-content">
                {/* Left - Single Image 1:1 */}
                <div className="image-group">
                    <img
                        src="/img/readytoplay.png"
                        alt={t('common.alt.dailyventsInDevices')}
                    />
                </div>
                {/* Right - Text + QR & Store Buttons */}
                <div className="text-container">
                    <Title className="title" level={2}>
                        {t('home.readyToPlay.title')}
                    </Title>
                    <Paragraph className="paragraph">
                        {t('home.readyToPlay.description')}
                    </Paragraph>

                    {/* QR + Store Buttons Grid */}
                    <div className="qr-store-buttons">
                        {/* QR Placeholder */}
                        <div className="qr-code">
                            <img
                                src="/img/qrcode.webp"
                                alt={t('common.alt.qrCode')}
                            />
                        </div>
                        <StoreButtons main="store-buttons" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReadyToPlay
